// @flow

/**
 * Creates an array of the specified size by calling the specified generator
 * function once for each array index. Useful for generating a series of
 * repeated values.
 */
export const repeat = <T>(
  times: number,
  generator: (index: number) => T,
): Array<T> => new Array(times).fill().map((_, index) => generator(index));
